import { useMemo } from 'react';
import { IntegratedApp } from '@/constants/apps';
import { useAppsByAppKey } from '@/api/queries/useAppsByAppKey';

export const useAvailableShopifyAppUrls = (appKey: string) => {
  const { data: apps, isLoading } = useAppsByAppKey(appKey);

  const stores = useMemo(() => {
    if (!apps) {
      return [];
    }

    const shopifyApps = apps.filter(
      (app) =>
        app.active &&
        [IntegratedApp.SHOPIFY, IntegratedApp.STUDIO_SHOPIFY].includes(
          app.app as IntegratedApp
        )
    );

    const appUrls = shopifyApps.map((app) => app.appUrl);

    return [...new Set(appUrls)];
  }, [apps]);

  return { stores, isLoading };
};
